import ErrorBoundary from './components/ErrorBoundary';
import { Layout } from './components/Layout';
import Router from './components/Router';
import { Toaster } from './components/ui/toast';
import { QueryMonitor } from './components/dev';

/**
 * Composant App principal
 * Architecture simplifiée : ErrorBoundary > Layout > Router
 */
function App() {
  return (
    <ErrorBoundary>
      <Toaster position="top-right" richColors closeButton />
      <Layout>
        <Router />
      </Layout>
      {/* Query Monitor - DEV only */}
      {import.meta.env.DEV && <QueryMonitor />}
    </ErrorBoundary>
  );
}

export default App;
